import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Observable, map, filter } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';
import { User, roleValueIDs } from 'src/app/models/user';
import { PaymentService } from 'src/app/services/payment.service';
import { UserService } from 'src/app/services/user.service';
import { isNativeApp } from 'src/app/utilities/native-app.utils';
import {
  IconTypes,
  PencilIconComponent,
} from 'src/app/standalones/components/pencil-icon/pencil-icon.component';
import {
  PencilButtonComponent,
  PencilButtonThemeEnum,
} from 'src/app/standalones/components/pencil-button/pencil-button.component';

@Component({
  selector: 'app-trial-banner',
  standalone: true,
  imports: [CommonModule, TranslateModule, PencilButtonComponent, PencilIconComponent],
  templateUrl: './trial-banner.component.html',
  styleUrls: ['./trial-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TrialBannerComponent {
  protected readonly PencilButtonThemeEnum = PencilButtonThemeEnum;
  protected readonly IconTypes = IconTypes;

  private readonly user$: Observable<User> = this.userService.user.pipe(
    map((res) => res?.user),
    filter((user): user is User => !!user),
  );

  protected readonly isTrialEligibleGuestUser$ = this.user$.pipe(
    map((user) => this.checkIsTrialEligibleGuestUser(user)),
  );

  constructor(
    private readonly paymentService: PaymentService,
    private readonly userService: UserService,
  ) {}

  private checkIsTrialEligibleGuestUser(user: User): boolean {
    const role = user.info?.role;
    return (
      !isNativeApp() &&
      !!user.feature_flags?.enable_billing &&
      !user.institution &&
      (role === roleValueIDs.teacher || role === roleValueIDs.admin)
    );
  }

  startFreeTrial(): void {
    this.paymentService.openStartTrialModal('payment_plans_trial_banner');
  }
}
